// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.silver-border-white-back {
  border-left: 1px solid silver;
  border-right: 1px solid silver;
  background-color: white;
}

.nowrap {
  white-space: nowrap;
}

.ellipses {
  border: 1px solid silver;
}

th {
  border: 1px solid silver;
  background-color: #f7f7f7;
  font-weight: bold;
  padding-top: 0px;
  padding-bottom: 0px;
}

.group-heading {
  border: 1px solid silver;
  background-color: #f7f7f7;
  font-weight: bold;
  padding-top: 0px;
  padding-bottom: 0px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.group-heading .heading-content {
  flex: 1;
}
.group-heading .heading-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  align-items: center;
}
.group-heading .add-components-button {
  font-size: 14px;
  color: #1976d2;
  background-color: transparent;
  border: none;
  padding: 0;
  height: auto;
  line-height: normal;
  border-radius: 0;
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.group-heading .add-components-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
.group-heading .add-components-button:hover {
  background-color: transparent;
}
.group-heading .add-components-button:focus {
  outline: 2px solid #1976d2;
  outline-offset: 2px;
}

.mat-icon {
  float: right;
}

.componentType {
  padding-left: 35px;
  font-weight: bold;
  background-color: white;
  border-right: 1px solid silver;
  vertical-align: middle;
  min-width: 220px;
}
.componentType .component-cell-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.componentType .component-cell-content .component-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.componentType .component-cell-content .component-info .drag-handle {
  cursor: move;
  color: #666;
  float: none;
  margin-right: 4px;
}
.componentType .component-cell-content .component-info .component-type-text {
  font-weight: bold;
}
.componentType .component-cell-content .component-info .new-item-icon {
  color: #4caf50;
  font-size: 18px;
}

.empty-cells {
  border-top: 1px solid silver;
  border-left: 1px solid silver;
  background-color: white;
}

.na {
  border-bottom: 1px solid silver;
}

td {
  padding: 5px;
  vertical-align: middle;
}

tr td:nth-child(2) {
  text-align: center;
}

tr td:nth-child(3) {
  text-align: center;
}

tr td:nth-child(4) {
  text-align: center;
}

tr td:nth-child(6) {
  text-align: center;
}

tr td:nth-child(7) {
  text-align: center;
}

table tr th,
table tr td {
  padding: 4px 6px;
  vertical-align: middle;
}

.note-container {
  display: flex;
  flex-direction: row;
  color: #0066b2;
  border-right-width: 0px;
  border-left-width: 0px;
  background-color: white;
}
.note-container .note-element {
  margin-right: 3px;
}
.note-container .note-element:hover {
  margin-right: 3px;
  cursor: pointer;
  text-decoration: underline;
  font-weight: bolder;
}

.edit-notes-button {
  margin-left: 8px;
  color: #0D47A1;
}
.edit-notes-button:hover {
  background-color: rgba(13, 71, 161, 0.04);
}

td {
  position: relative;
  vertical-align: middle;
}

.cell-content-with-add {
  display: flex;
  align-items: center;
  min-height: 24px;
  min-width: 90px;
}

.cell-content-with-edit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
}

.add-text-link {
  color: #1976d2;
  cursor: pointer;
  text-decoration: none;
  font-size: 14px;
  font-family: "GothamBold", Arial, sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.add-text-link mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
}
.add-text-link:hover {
  text-decoration: underline;
  font-weight: bolder;
}

.notes-add-button.inline-add {
  font-weight: 400;
}

.edit-text-link {
  color: #1976d2;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
}
.edit-text-link:hover {
  background-color: rgba(13, 71, 161, 0.04);
}
.edit-text-link mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.notes-edit-button.inline-add {
  margin-left: 8px;
}

.nps-cell {
  position: relative;
}

.nps-display-container {
  display: flex;
  align-items: center;
  gap: 8px;
}
.nps-display-container .nps-value {
  flex: 1;
}
.nps-display-container .edit-nps-button {
  width: 24px;
  height: 24px;
  padding: 0;
  opacity: 0;
  transition: opacity 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nps-display-container .edit-nps-button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #666;
  margin: 0;
}
.nps-display-container .edit-nps-button:hover mat-icon {
  color: #1976d2;
}

.nps-edit-container {
  display: flex;
  align-items: center;
}
.nps-edit-container .nps-input {
  flex: 1;
  min-width: 80px;
}
.nps-edit-container .nps-input ::ng-deep .mat-form-field-wrapper {
  margin-bottom: 0;
  padding-bottom: 0;
}
.nps-edit-container .nps-input ::ng-deep .mat-form-field-infix {
  border-top: none;
  padding: 4px 0;
}
.nps-edit-container .nps-input ::ng-deep .mat-form-field-outline {
  top: 0;
}
.nps-edit-container .save-nps-button,
.nps-edit-container .cancel-nps-button {
  width: 24px;
  height: 24px;
  line-height: 24px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.nps-edit-container .save-nps-button mat-icon,
.nps-edit-container .cancel-nps-button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin: 0;
}
.nps-edit-container .save-nps-button mat-icon {
  color: #4caf50;
}
.nps-edit-container .cancel-nps-button mat-icon {
  color: #f44336;
}

td:hover .edit-nps-button {
  opacity: 1;
}

.draggable-row {
  cursor: move;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.draggable-row.cdk-drag {
  cursor: grabbing;
}
.draggable-row.cdk-drag-disabled {
  cursor: default;
}
.draggable-row.cdk-drag-preview {
  background-color: #f5f5f5;
  border: 2px solid #1976d2;
  border-radius: 4px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  transform: rotate(3deg);
}
.draggable-row.cdk-drag-placeholder {
  opacity: 0.4;
  background-color: #e3f2fd;
  border: 2px dashed #1976d2;
}
.draggable-row.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.drag-handle {
  display: inline-block;
  cursor: grab;
  color: #666;
  opacity: 0;
  transition: opacity 0.2s ease;
  margin-right: 8px;
  vertical-align: middle;
}
.drag-handle:hover {
  color: #1976d2;
}
.drag-handle:active {
  cursor: grabbing;
}

.draggable-row:hover .drag-handle {
  opacity: 1;
}

.compare-row-new td {
  background-color: #e8f5e9 !important;
}

.compare-row-deleted td {
  background-color: #ffebee !important;
  color: #6d2a2a;
  text-decoration: line-through;
}

.componentType {
  position: relative;
  vertical-align: middle;
}

.nps-input.error ::ng-deep .mat-form-field-outline {
  color: #f44336;
}

.nps-input.error ::ng-deep .mat-form-field-label {
  color: #f44336;
}

.save-nps-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.save-nps-button:disabled mat-icon {
  color: #ccc;
}

.fa-trash-can {
  color: #97002e;
  margin-left: 5%;
  cursor: pointer;
}

.delete-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: #fff;
}

.component-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}

.catalog-indicator-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  border-radius: 50%;
  transition: background 0.15s;
}
.catalog-indicator-button:hover {
  background: rgba(0, 0, 0, 0.06);
}

.catalog-indicator-upgrade {
  color: #f57c00;
}

.catalog-indicator-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 14px;
  cursor: default;
}

.catalog-indicator-outdated {
  color: #f57c00;
}

.catalog-indicator-deprecated {
  color: #c62828;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
